import { useMemo } from 'react'
import { completionKey, isDayComplete, parsePrescription, toISODate } from '../lib/exercise'

function Today({ profile, plan, completion, onToggle, onOpenDetail }) {
  const previewDate = useMemo(() => {
    const dates = Object.keys(plan).sort()
    if (dates.length === 0) {
      return null
    }

    const today = toISODate(new Date())
    return dates.find((date) => date >= today) ?? dates[dates.length - 1]
  }, [plan])

  const previewPlan = previewDate ? plan[previewDate] : null
  const isToday = previewDate === toISODate(new Date())
  const doneCount = previewPlan
    ? previewPlan.exercises.filter((exercise) => completion[completionKey(previewDate, exercise.name)]).length
    : 0
  const dayComplete = previewPlan ? isDayComplete(previewPlan, previewDate, completion) : false

  return (
    <main className="screen">
      <section className="dashboard-header">
        <p className="eyebrow">Hola, {profile.fullName.split(' ')[0]}</p>
        <h1>{isToday ? 'Entrenamiento de hoy' : 'Proxima sesion'}</h1>
        {previewPlan && <p className="subtitle">{previewPlan.focus}</p>}
      </section>

      {previewPlan && previewDate ? (
        <section className="today-card">
          <div className="sheet-progress">
            <div className="progress-track">
              <div
                className="progress-fill"
                style={{ width: `${(doneCount / previewPlan.exercises.length) * 100}%` }}
              />
            </div>
            <span>
              {doneCount}/{previewPlan.exercises.length} completados
            </span>
          </div>

          {dayComplete && isToday && (
            <p className="day-complete-message">Entrenamiento de hoy completado. Buen trabajo.</p>
          )}

          <ul className="exercise-list">
            {previewPlan.exercises.map((exercise) => {
              const data = parsePrescription(exercise.prescription)
              const key = completionKey(previewDate, exercise.name)
              const done = Boolean(completion[key])

              return (
                <li key={exercise.name} className={`exercise-row ${done ? 'done' : ''}`}>
                  <label className="exercise-check">
                    <input type="checkbox" checked={done} onChange={() => onToggle(previewDate, exercise.name)} />
                    <button
                      type="button"
                      className="exercise-row-body"
                      onClick={() => onOpenDetail(previewDate)}
                    >
                      <span className="exercise-row-name">{exercise.name}</span>
                      <span className="exercise-row-meta">
                        <strong>{data.series}</strong> series &middot; <strong>{data.reps}</strong> reps/seg
                      </span>
                    </button>
                  </label>
                </li>
              )
            })}
          </ul>

          <button type="button" className="primary full-width" onClick={() => onOpenDetail(previewDate)}>
            Ver dibujo y detalle
          </button>
        </section>
      ) : (
        <section className="today-card">
          <p>No hay sesiones programadas todavia.</p>
        </section>
      )}
    </main>
  )
}

export default Today
